
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HiddenInput',

  data: () => ({
    showValue: false,
  }),

  methods: {
    validate() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return (this.$refs.input as any).validate();
    }
  }
});
